import React from 'react'
import { Box } from 'rebass'
import IconIn from '../Icon'
import styled from 'styled-components'
import sys from '@rebass/components'

export const TextInput = styled(({ _ref, onChangeText, ...rest }) => (
  <input ref={_ref} onChange={e => onChangeText(e.target.value)} {...rest} />
))`
  font-family: inherit;
`

export const Icon = sys(
  {
    is: IconIn
  },
  'space',
  'color'
)

export {
  Base as View,
  Card,
  Box,
  Flex,
  Text,
  Heading,
  BlockLink,
  Absolute
} from 'rebass'

export const ScrollView = Box.extend`
  overflow-x: auto;
  overflow-y: ${props => (props.horizontal ? 'none' : 'auto')};
`
